module.exports = __webpack_public_path__ + "static/media/loadingDot.8e174af8.gif";